import ApiManager from "@/utils/ApiManager"
import Utility from "@/utils/Utility"
import Vue from "vue"

const state = {
  categoryName: "リンク集カテゴリ",

  // form
  values: [],
  originalValues: []
}

const getters = {
  get: state => state,

  // 登録値を表示用に変換
  getValue: state => key => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
      /* eslint-disable no-new */
    } catch (e) {
      return ""
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   * リンク集カテゴリ取得
   *
   * @param commit
   * @param serviceLinkCategoryParams
   * @returns {Promise<unknown>}
   */
  getLinkCategory({ commit }, serviceLinkCategoryGetParams) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ["serviceLinkCategory"],
        ["v1ServiceLinkCategoryListGet"],
        [serviceLinkCategoryGetParams]
      )
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            commit("setLinkCategory", res[0].data.link_categories)
            resolve()
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * リンク集カテゴリ登録
   * @param commit
   * @param serviceLinkCategoryParams
   * @returns {Promise<unknown>}
   */
  storeLinkCategory({ commit }, serviceLinkCategoryStoreParams) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ["serviceLinkCategory"],
        ["v1ServiceLinkCategoryPost"],
        [serviceLinkCategoryStoreParams]
      )
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            resolve()
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * リンク集カテゴリ更新
   * @param commit
   * @param serviceLinkCategoryParams
   * @returns {Promise<unknown>}
   */
  updateLinkCategory({ commit }, serviceLinkCategoryUpdParams) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ["serviceLinkCategory"],
        ["v1ServiceLinkCategoryPatch"],
        [serviceLinkCategoryUpdParams]
      )
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            resolve()
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * リンク集カテゴリ削除
   * @param commit
   * @param serviceLinkCategoryParams
   * @returns {Promise<unknown>}
   */
  deleteLinkCategory({ commit }, serviceLinkCategoryDelParams) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ["serviceLinkCategory"],
        ["v1ServiceLinkCategoryDelete"],
        [serviceLinkCategoryDelParams]
      )
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            resolve()
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * リセット
   */
  reset({ commit }) {
    commit("reset")
  }
}

const mutations = {
  setLinkCategory(state, data) {
    // データ未登録の場合はjsonbフォーマットを作成
    if (!data || !data.length) {
      data = []
    }
    Vue.set(state, "values", data)
    Vue.set(state, "originalValues", JSON.parse(JSON.stringify(data)))
  },

  // reset
  reset(state) {
    Vue.set(state, "values", [])
    Vue.set(state, "originalValues", [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
